import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import i18n from 'i18next';
import config from "../../configuration/config";
import { getData, User_Data_Key } from "../../utils/localStorageManager";

// مفتاح الكاش الموحد
const userCarsQueryKey = ['user-cars'];

// دالة جلب بيانات السيارات
const fetchUserCars = async () => {
    const _userID = JSON.parse(getData(User_Data_Key, true)).id.toString().split('_')[1];
    const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteGetUserCars`, {
        userID: Number(_userID),
    });

    return response.data;
};



// الهوك الرئيسي
export default function useUserCars() {
    return useQuery({
        queryKey: userCarsQueryKey,
        queryFn: fetchUserCars,
        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 30,
        refetchOnWindowFocus: false,
        retry: 1,
    });
}

// دالة مخصصة لإعادة جلب البيانات — تُستخدم في أي مكان
export const useInvalidateUserCars = () => {
    const queryClient = useQueryClient();
    return () => queryClient.invalidateQueries(userCarsQueryKey);
};


// ✅ دالة جلب تفاصيل سيارة معينة
const fetchUserCarDetails = async ({ queryKey }) => {


    const [, vehicleID, fetchType] = queryKey;
    const funSiteGetVehicleDetails =
        fetchType === "user" ? "SiteGetVehicleDetails" : "SiteGetVehiclePurchase";

    if (!vehicleID) return null;

    const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/${funSiteGetVehicleDetails}`, {
        vehicleID: vehicleID,
    });

    return response.data && response.data?.length > 0 ? response.data[0] : null;
};

// ✅ هوك لجلب تفاصيل سيارة معينة مع إدارة الكاش
export function useUserCarDetails(vehicleID, fetchType = "user") {

    return useQuery({
        queryKey: ['user-car-details', vehicleID, fetchType],
        queryFn: fetchUserCarDetails,
        enabled: !!vehicleID, // لا ينفذ إلا عند توفر ID

        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 30,
        refetchOnWindowFocus: false,
        retry: 1,
    });
}
// ✅ دالة مخصصة لإعادة جلب تفاصيل سيارة معينة
export const useInvalidateUserCarDetails = () => {
    const queryClient = useQueryClient();
    return (vehicleID, fetchType = "user") =>
        queryClient.invalidateQueries(['user-car-details', vehicleID, fetchType]);
};